module.exports = __webpack_public_path__ + "img/mexico.1a51eb08.png";